var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Box",
    { attrs: { title: "Führerscheinklassen", faulty: _vm.faulty } },
    [
      _c(
        "FormGroup",
        {
          attrs: {
            label: "Besitzt du einen Führerschein?",
            state: _vm.hasDrivingLicenseValid
          }
        },
        [
          _c("Select", {
            attrs: {
              options: _vm.hasDrivingLicenseOptions,
              "undefined-text-option-text":
                "--- Bitte wähle eine Führerscheinklasse aus ---"
            },
            on: { input: _vm.hasDrivingLicenseChanged },
            model: {
              value: _vm.hasDrivingLicense,
              callback: function($$v) {
                _vm.hasDrivingLicense = $$v
              },
              expression: "hasDrivingLicense"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.classesEligible
        ? _c(
            "div",
            { staticClass: "mt-3" },
            _vm._l(_vm.classes, function(item, i) {
              return _c(
                "div",
                { key: item.id, staticClass: "inner-box mb-3" },
                [
                  _c("div", { staticClass: "top-row" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("Führerscheinklasse")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "actions" }, [
                      item.item || i > 0
                        ? _c(
                            "a",
                            {
                              directives: [
                                { name: "b-tooltip", rawName: "v-b-tooltip" }
                              ],
                              attrs: {
                                href: "#",
                                title: "Führerscheinklasse löschen"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.classToRemove = item
                                }
                              }
                            },
                            [
                              _c("Icon", {
                                attrs: { icon: "bin", color: "red" }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "FormGroup",
                        { attrs: { state: item.item !== undefined } },
                        [
                          _c("SingleSelect", {
                            attrs: {
                              characteristics: _vm.meta.drivingLicenseClass,
                              "exclude-ids": _vm.getIdsToExclude(item),
                              "undefined-text-option-text":
                                "--- Bitte wähle eine Führerscheinklasse aus ---"
                            },
                            model: {
                              value: item.item,
                              callback: function($$v) {
                                _vm.$set(item, "item", $$v)
                              },
                              expression: "item.item"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.moreEligible
        ? _c(
            "FormGroup",
            {
              staticClass: "mt-3",
              attrs: {
                label: "Besitzt du noch eine weitere Führerscheinklasse?",
                state: _vm.more === undefined
              }
            },
            [
              _c("MoreSelect", {
                attrs: {
                  options: _vm.moreOptions,
                  "undefined-text-option-text":
                    "--- Bitte triff eine Auswahl ---"
                },
                on: { input: _vm.moreChanged },
                model: {
                  value: _vm.more,
                  callback: function($$v) {
                    _vm.more = $$v
                  },
                  expression: "more"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.classToRemove
        ? _c(
            "ConfirmPopUp",
            {
              attrs: { title: "Führerscheinklasse löschen" },
              on: {
                confirm: _vm.onRemove,
                hidden: function($event) {
                  _vm.classToRemove = undefined
                }
              }
            },
            [
              _vm._v("\n\t\tMöchtest du die "),
              _c("b", [
                _vm._v(
                  "Führerscheinklasse " +
                    _vm._s(
                      _vm.classToRemove.item ? _vm.classToRemove.item.label : ""
                    )
                )
              ]),
              _vm._v(" wirklich\n\t\tlöschen?\n\t")
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }